var map = {
	"./b.png": 134,
	"./bauddhikgeeks-transparent.png": 135,
	"./bauddhikgeeks.png": 136,
	"./buld.jpg": 137,
	"./cwoc.png": 138,
	"./davex.png": 139,
	"./dhaib.jpg": 140,
	"./efi.png": 141,
	"./flutter.png": 142,
	"./gdg.png": 143,
	"./github.png": 144,
	"./googleAssistant.jpg": 145,
	"./google_logo.png": 146,
	"./gtu.png": 147,
	"./hackathon1.svg": 148,
	"./harikrushn.jpg": 149,
	"./iit.png": 150,
	"./ino.png": 151,
	"./localguide.gif": 152,
	"./localguide.png": 153,
	"./maginno.png": 154,
	"./mlh-logo.png": 155,
	"./mlh-logo.svg": 156,
	"./mlh.png": 157,
	"./mongo.png": 158,
	"./nightowls.jpg": 159,
	"./postman.jpg": 160,
	"./postman.png": 161,
	"./skillenza.png": 162,
	"./ssec.png": 163,
	"./ssgandhy.png": 164,
	"./traxion.png": 165,
	"./traxion2.png": 166,
	"./valora.jpg": 167,
	"./vector.png": 45,
	"./wrighter.jpg": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;